import { render, staticRenderFns } from "./LmProfileGroups.vue?vue&type=template&id=788bacd8"
import script from "./LmProfileGroups.vue?vue&type=script&lang=js"
export * from "./LmProfileGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports